import { useEffect, useState, useRef } from "react";
import Loading from "../components/Loading/Loading";
import {
  makeStyles,
  Grid,
  TextField,
  Button,
  Snackbar,
} from "@material-ui/core";
import CustomButton from "../components/common/controls/CustomButton";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import DMModal from "../components/common/controls/DMModal";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import * as miscAction from "../actions/miscAction";
import * as modelAction from "../actions/modelAction";
import { connect } from "react-redux";
import * as currencyAction from "../actions/currencyAction";

var CONTROLS_DATA = require("./ControlsData.json");
var CURRENCY_CONTROLS = CONTROLS_DATA.SCREENS.CURRENCIES;

const Currency = ({ getCurrencies, createNewCurrency, updateCurrency, deleteCurrency, currencyState, modelState, onPageSelected, setSnackBar }) => {
  const [currencyId, setCurrencyId] = useState("");
  const [currencyName, setCurrencyName] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [showNewModel, setShowNewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [selectedModel, setSelectedModel] = useState();
  const [newModel, setNewModel] = useState();
  const [isDisabled, setIsDisabled] = useState(true);
  const [showDelete, setShowDelete] = useState(false);
  const prevGridDataRef = useRef();
  const newCurrencyOnClick = () => { setCurrencyName(""); setCurrencySymbol(""); setShowNewModel(true);}

  const onEdit = (cId,cName,cSymbol) => {
    setCurrencyId(cId);
    setCurrencyName(cName);
    setCurrencySymbol(cSymbol);
    setShowEditModel(true);
  };

  const onDelete = (cId,cName) => {
    setCurrencyId(cId);
    setCurrencyName(cName);
    setShowDelete(true);
  };

  
  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "75%",
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "60% 35% 5%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Arial",
      fontWeight: "500",
    },
  }));

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }
  const classes = useStyles();

  const [modalStyle] = useState(getModalStyle);

  useEffect( () => {
    const fetchCurrecy = async () => {
      try {
        await getCurrencies();
      } catch (error) {
        console.log("get currency fails", error);
      }
    }
    fetchCurrecy()
  }, [getCurrencies]);

  useEffect(() => {
    const ctrlData = [];
    currencyState && currencyState.forEach((model) => {
      ctrlData.push({
        rowKey: model.currencyId,
        currencyName: model.currencyName,
        currencySymbol: model.currencySymbol,
        rowValue: [
          {
            colType: "grid-label",
            colOptions: {
              width: "100px",
              value: model?.currencyName,
              tab: "tools",
              model: model,
              //onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "user-grid-label",
            colOptions: {
              width: "100px",
              value: model?.currencySymbol,
              tab: "tools",
              model: model,
              //onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "grid-actions",
            colOptions: [
              {
                name: "edit",
                tab: "tools",
                action: () => onEdit(model.currencyId, model.currencyName, model.currencySymbol),
                width: "100px",
              },
              {
                name: "delete",
                action: () => onDelete(model.currencyId, model.currencyName),
              },
            ],
          },
        ],
      });
    });
    setGridData(ctrlData);
  }, [currencyState]);

  const handleCreateCurrency = async () => {
    if(currencyName && currencySymbol){
    try {
      const payload = {
        currencyName: currencyName,
        currencySymbol: currencySymbol
      };
      await createNewCurrency(payload);
      await getCurrencies();
      setSnackBar(true, "success", `Created new currency ${currencyName}`);
      setLoading(false);
      setShowNewModel(false);
    } catch (error) {
      setShowNewModel(false);
      setSnackBar(true,"error",`Error while creating a new currency ${currencyName}`);
    }
  }else {
      setSnackBar(true, "error", `Please enter currency name & currency symbol!`);
      setLoading(false);
  }
  };

  const handleEditSaveCurrency = async () => {
    const payload = {
      currencyId: currencyId,
      currencyName: currencyName,
      currencySymbol: currencySymbol
    };
    setLoading(true);
    if(currencyName && currencySymbol){
    try {
      await updateCurrency(currencyId, payload);
      await getCurrencies();
      setSnackBar(true, "success", `Update new currency ${currencyName}`);
      setShowEditModel(false);
      setLoading(false);
    } catch (error) {
      setShowEditModel(false);
      setSnackBar(true, "error", `Error while updating a new currency`);
      setLoading(false);
    }
  } else {
      setSnackBar(true, "error", `Please enter currency name & currency symbol!`);
      setLoading(false);
  }
  };

  const deleteConfirm = async () => {
    try {
      const payload = {
        currencyId: currencyId,
        currencyName: currencyName,
        currencySymbol: currencySymbol
      };
      await deleteCurrency(payload.currencyId);
      await getCurrencies();
      setSnackBar(true,"success",`${currencyName} has been deleted.`);
      setLoading(false);
      setShowDelete(false);
    } catch (error) {
      setSnackBar(true,"error",`Error while deleting model ${currencyName}`);
    }
  };
  
  const onSelectedPage = (selectedPage) => {
    onPageSelected(selectedPage);
  };

  return (
    <div container className="page-container content-center">
      <Loading open={loading} />
      <Grid container xs={12} md={11} className="page-content">
        <Grid item container xs={12} md={12} justify="flex-end">
          <CustomButton
            id="newModel"
            showGradient={true}
            variant="contained"
            color="primary"
            disabled={false}
            name="Add Currency"
            onClick={newCurrencyOnClick}
          />
        </Grid>
        <Grid item container xs={12} md={10}>
          {gridData && gridData?.length > 0 && (
            <DMGrid
              key={Math.random()}
              headers={CURRENCY_CONTROLS.GRID_HEADERS}
              headerClassName={classes.gridHeaderColumns}
              data={gridData}
              loading={loading}
              selectedPage={modelState.selectedPage}
              onPageSelection={onSelectedPage}
              setGridData={(t) => {
                setGridData(t);
              }}
            />
          )}
        </Grid>
        <DMModal open={showNewModel} onClose={() => setShowNewModel(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">New Currency</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <TextField
                id="outlined-basic-userName"
                label="Currency Name*"
                variant="outlined"
                autoComplete="off"
                type="text"
                value={currencyName}
                onChange={(e) => setCurrencyName(e.target.value)}
              />
              <TextField
                id="outlined-basic-userEmail"
                label="Currency Symbol*"
                variant="outlined"
                autoComplete="off"
                type="text"
                value={currencySymbol}
                onChange={(e) => setCurrencySymbol(e.target.value)}
              />
              <Grid
                  item
                  xs={12}
                  container
                  style={{ justifyContent: "center" }}
                >
                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setIsDisabled(true);
                        setShowNewModel(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={handleCreateCurrency}
                      // disabled={isDisabled}
                      className="makeStyles-gradient-27"
                    >
                      OK
                    </Button>
                  </Grid>
                </Grid>
            </div>            
          </div>
        </DMModal>
        <DMModal open={showEditModel} onClose={() => setShowEditModel(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">Edit Currency</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <TextField
                id="outlined-basic-userName"
                label="Currency Name*"
                variant="outlined"
                autoComplete="off"
                type="text"
                value={currencyName}
                onChange={(e) => setCurrencyName(e.target.value)}
              />
              <TextField
                id="outlined-basic-userEmail"
                label="Currency Symbol*"
                variant="outlined"
                autoComplete="off"
                type="text"
                value={currencySymbol}
                onChange={(e) => setCurrencySymbol(e.target.value)}
              />
                <Grid
                  item
                  xs={12}
                  container
                  style={{ justifyContent: "center" }}
                >
                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setIsDisabled(true);
                        setShowEditModel(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={handleEditSaveCurrency}
                      // disabled={isDisabled}
                      className="makeStyles-gradient-27"
                    >
                      Ok
                    </Button>
                  </Grid>
                </Grid>
              </div>
          </div>
        </DMModal>
        <DMDeleteDialog
          open={showDelete}
          onClose={() => setShowDelete(false)}
          // title={"Are you sure to delete?"}
          contentText={`${currencyName} will be deleted.`}
          discardText={"Cancel"}
          agreeText={"OK"}
          onProceed={() => {
            deleteConfirm(currencyName);
          }}
        />
      </Grid>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currencyState: state.currency.currencies?.data || [],
  modelState: state.model,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getCurrencies: async () => dispatch(currencyAction.getCurrencies()),
    createNewCurrency: async (requestPayload) =>
      dispatch(currencyAction.createNewCurrency(requestPayload)),
    updateCurrency: async (currencyId, requestPayload) =>
      dispatch(currencyAction.updateCurrency(currencyId, requestPayload)),
    deleteCurrency: async (requestPayload) =>
      dispatch(currencyAction.deleteCurrency(requestPayload)),
    deleteModel: async (requestPayload) =>
      dispatch(modelAction.deleteModel(requestPayload)),
    createNewModel: async (requestPayload) =>
      dispatch(modelAction.createNewModel(requestPayload)),
    onMoreOptionsSelected: (modelId) =>
      dispatch(miscAction.onModelSelected(modelId)),
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    onPageSelected: (selectedPage) =>
      dispatch(modelAction.setModelSelectedPage(selectedPage)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Currency);
